/**
 * Datatable definition for the Vendors table.
 */


var app_admin_users_table = $('#app-admin-users-table');

if (app_admin_users_table.length) {
    var data_table_order=[1, "asc"];
    var users_table;
    function initializeAdminUsersTable() {
        users_table = window.app_admin_users_table.DataTable({
            ajax: {
                url: '/users/list',
                dataSrc: 'data'
            },
            columns: [
                {data: 'id'},
                {data: 'agency.name'},
                {data: 'name'},
                {data: 'email'},
                {data: 'roles.0.display_name'},
                {data: 'manager_name'},
                {data: 'slug'}
            ],
            pageLength: user_entries,
            order: data_table_order,
            destroy: true,
            "columnDefs": [{
                "targets": 6,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    disabledClass = '';
                    if (rowData.id == 1)
                        disabledClass = ' disabled';
                    // var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                    //     '<a href="/user/' + ((typeof rowData.agency !== 'undefined' && rowData.agency !== null) ? rowData.agency.id : '') + '/' +
                    //     cellData +
                    //     '" role="button" class="btn btn-success btn-sm">' +
                    //     '<i class="fa fa-pencil"></i>' +
                    //     '</a>';
                    // if (rowData.id == 1)
                    //     html = html + '<a href="javascript:void(0)"  role="button" class="btn btn-danger btn-sm' + disabledClass + '">';
                    // else
                    //     html = html + '<a href="javascript:void(0)" id="row_' + rowData.id + '" onclick="deleteAdminUser(\'' + rowData.slug + '\',' + rowData.id + ')" role="button" class="btn btn-danger btn-sm">';
                    // html = html + '<i class="fa fa-trash-o"></i>' +
                    //     '</a></div>';

                    var html = '<div class="btn-group">\n' +
                    '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                    '                <i class="fa fa-ellipsis-v"></i>\n' +
                    '                <span class="sr-only">Toggle Dropdown</span>\n' +
                    '            </button>\n' +
                    '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                    '                <li class="ms-hover">' + '<a href="/user/' + cellData + '">' + '<i class="fa fa-pencil"></i> Edit' + '</a>' + '</li>\n' +
                    '                <li class="ms-hover">' + ((rowData.id == 1) ? ('<a href="javascript:void(0)" ' + disabledClass + '"><i class="fa fa-trash-o"></i> Delete</a>')
                        : ('<a href="javascript:void(0)" onclick="deleteUser(\'' + rowData.slug + '\',' + rowData.id + ')"><i class="fa fa-trash-o"></i> Delete</a>')) + '</li>\n' +
                        '                <li role="separator" class="divider ms-hover"></li>\n' +
                        // '                <li class="ms-hover"><a href="javascript::;"></a></li>\n'
                    '            </ul>\n' +
                    '        </div>';

                    $(td).html(html);
                }
            },
                {
                    "targets": 5,
                    "visible": false,
                }]
        });
    }
    $('#app-admin-users-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-admin-users-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );

    function deletedUserConfirm() {
        show_loader();
        var slugData =  $('#deletedUserConfirm').attr('data-slug')
        var idData = $('#deletedUserConfirm').attr('data-id')
        $.ajax({
            url: '/users/destroy',
            type: "POST",
            data: {
                '_token': $('meta[name="csrf-token"]').attr('content'),
                'user_slug': slugData,
                'user_id': idData
            },
            success: function (response) {
                global_notification('success', 'User deleted.');
                if(typeof users_table !== "undefined")
                    users_table.row( $('a#row_' + idData).parents('tr') ).remove().draw();
                else
                    initializeAdminUsersTable();
                $('#deleteUserWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                  //  global_notification('warning', xhr.responseJSON.message);
                    $('#deleteUserWarningModal').modal('hide');
                    $('#generalWarningModalDiv').html(xhr.responseJSON.message);
                    $('#generalWarningModal').modal('show');
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                hide_loader();
            }
        });
    }
    function deleteAdminUser(slugData, idData) {
        $('#deletedUserConfirm').attr('data-slug', slugData)
        $('#deletedUserConfirm').attr('data-id', idData)
        $('#deleteUserWarningModal').modal('show');
    }

    initializeAdminUsersTable();
}

var app_users_table = $('#app-users-table');

if (app_users_table.length) {
    function initializeUsersTable() {
        window.app_users_table.DataTable({
            ajax: {
                url: '/users/list',
                dataSrc: 'data'
            },
            columns: [
                {data: 'name'},
                {data: 'email'},
                {data: 'roles.0.display_name'},
                {data: 'manager_name'},
                {data: 'slug'}
            ],
            destroy: true,
            "columnDefs": [{
                "targets": 4,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    disabledClass = '';
                    if (rowData.id == 1)
                        disabledClass = ' disabled';
                    // var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                    //     '<a href="/user/' +
                    //     cellData +
                    //     '" role="button" class="btn btn-success btn-sm">' +
                    //     '<i class="fa fa-pencil"></i> Edit' +
                    //     '</a>';
                    // if (rowData.id == 1)
                    //     html = html + '<a href="javascript:void(0)"  role="button" class="btn btn-danger btn-sm' + disabledClass + '">';
                    // else
                    //     html = html + '<a href="javascript:void(0)" onclick="deleteUser(\'' + rowData.slug + '\',' + rowData.id + ')" role="button" class="btn btn-danger btn-sm">';
                    // html = html + '<i class="fa fa-trash-o"></i> Delete' +
                    //     '</a></div>';


                    var html = '<div class="btn-group">\n' +
                        '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                        '                <i class="fa fa-ellipsis-v"></i>\n' +
                        '                <span class="sr-only">Toggle Dropdown</span>\n' +
                        '            </button>\n' +
                        '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                        '                <li class="ms-hover">' + '<a href="/user/' + cellData + '">' + '<i class="fa fa-pencil"></i> Edit' + '</a>' + '</li>\n' +
                        '                <li class="ms-hover">' + ((rowData.id == 1) ? ('<a href="javascript:void(0)" ' + disabledClass + '"><i class="fa fa-trash-o"></i> Delete</a>')
                            : ('<a href="javascript:void(0)" onclick="deleteUser(\'' + rowData.slug + '\',' + rowData.id + ')"><i class="fa fa-trash-o"></i> Delete</a>')) + '</li>\n' +
                        '                <li role="separator" class="divider ms-hover"></li>\n' +
                        '                <li class="ms-hover"><a href="javascript::;"></a></li>\n'
                    '            </ul>\n' +
                    '        </div>';

                    $(td).html(html);
                }
            }]
        });
    }

    function deleteUser(slugData, idData) {
        swal({
                title: "Warning",
                text: "Are you sure you want to delete?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: '/users/destroy',
                        type: "POST",
                        data: {
                            '_token': $('meta[name="csrf-token"]').attr('content'),
                            'user_slug': slugData,
                            'user_id': idData
                        },
                        success: function (response) {
                            global_notification('success', 'User deleted.');

                            initializeUsersTable();
                            hide_loader();
                        },
                        error: function (xhr) {
                            if (xhr.status === 422) {
                                global_notification('warning', xhr.responseJSON.message);
                            } else {
                                ajax_error();
                                debug(xhr.responseText);
                            }
                            hide_loader();
                        }
                    });
                }
            });


    }

    initializeUsersTable();
}
